/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linkidentity_Linkfailed2Inputs */

const zh_linkidentity_linkfailed2 = /** @type {(inputs: Linkidentity_Linkfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`绑定失败`)
};

const en_linkidentity_linkfailed2 = /** @type {(inputs: Linkidentity_Linkfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to link account`)
};

const es_linkidentity_linkfailed2 = /** @type {(inputs: Linkidentity_Linkfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al vincular cuenta`)
};

/**
* | output |
* | --- |
* | "Failed to link account" |
*
* @param {Linkidentity_Linkfailed2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const linkidentity_linkfailed2 = /** @type {((inputs?: Linkidentity_Linkfailed2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linkidentity_Linkfailed2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_linkidentity_linkfailed2(inputs)
	if (locale === "en") return en_linkidentity_linkfailed2(inputs)
	return es_linkidentity_linkfailed2(inputs)
});
export { linkidentity_linkfailed2 as "linkIdentity_linkFailed" }